export {
    SuiModalModule,
    SuiModalService,
    Modal as SuiModal,
    ModalResult,
    ModalControls,
    ActiveModal as SuiActiveModal,
    ModalConfig,
    TemplateModalConfig,
    ComponentModalConfig,
    ModalTemplate,
    ModalSize,
    SuiModal as SuiModalComponent
} from "./index";
